<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-white border-bottom p-3">
    <div class="w-100">
      <div class="row mx-1">
        <div class="col-6 d-flex align-items-center" :class="{ 'justify-content-between col-12': !$store.state.responsive.viewDesktopFilters, 'col-6': $store.state.responsive.viewDesktopFilters  }">
          <a href="#" id="menuIcon" aria-label="Menú hamburguesa" @click="changeCollapse()" :class="{ 'mobileView': !$store.state.responsive.viewDesktopFilters }">
            <span class="mr-4">
              <v-icon name="oi-three-bars" scale="1.3" />
            </span>
          </a>
          <div class="d-flex align-items-center">
            <div v-if="!$store.state.responsive.viewDesktopFilters && notifications.length > 0 && !$store.state.roles.Backoffice_member_empresas" class="float-left mr-2 position-relative align-items-center">
              <div class="" id="dropdownOperations2" data-toggle='dropdown'
              aria-haspopup="true">
              <span class="float-left mr-2">
                <v-icon name="md-notificationsactive-round" style="cursor: pointer;" scale="1.2" />
              </span>
              <span class="numberNotification">
                {{ notifications.length }}
              </span>
              </div>
              <div class="dropdown-menu p-0 dropdown-menu-right" aria-labelledby="dropdownOperations2">
                <span v-for="(notification, index) in notifications" v-bind:key="index" class="d-flex align-items-center">
                <a class="dropdown-item py-3 px-4" style="cursor: pointer;" @click="notificationsUrl(notification)">
                  <v-icon name="notification-on" class="mr-2" scale="1.2" />
                  {{ notification.description }}
                </a>
                </span>
              </div>
            </div>
            <router-link class="btn generalTertiaryButton" :to="{ name: 'newContractStep1' }" @click="removeVuex()">Iniciar
              contrato
            </router-link>
          </div>
        </div>
        <div :class="{ 'd-none': !$store.state.responsive.viewDesktopFilters, 'col-6 d-flex align-items-center justify-content-end': $store.state.responsive.viewDesktopFilters  }">
          <div v-if="notifications.length > 0 && !$store.state.roles.Backoffice_member_empresas" class="float-left mr-2 position-relative">
            <div class="" id="dropdownOperations2" data-toggle='dropdown'
            aria-haspopup="true">
            <span class="float-left mr-2">
              <v-icon name="md-notificationsactive-round" style="cursor: pointer;" scale="1.2" />
            </span>
            <span class="numberNotification">
              {{ notifications.length }}
            </span>
            </div>
            <div class="dropdown-menu p-0 dropdown-menu-right" aria-labelledby="dropdownOperations2">
              <span v-for="(notification, index) in notifications" v-bind:key="index" class="d-flex align-items-center">
              <a class="dropdown-item py-3 px-4" style="cursor: pointer;" @click="notificationsUrl(notification)">
                <v-icon name="notification-on" class="mr-2" scale="1.2" />
                {{ notification.description }}
              </a>
              </span>
            </div>
          </div>
          <div class="mr-4" v-if="channel && !$store.state.roles.Backoffice_member_empresas">
            <span class="float-left mr-2">
              <v-icon name="bi-globe" scale="1.2" title="Canal" />
            </span>
            <p class="float-left mb-0">{{ channel }}</p>
          </div>
          <div class="mr-4" v-if="tenant">
            <span class="float-left mr-2">
              <v-icon name="fa-building" scale="1.2" title="Tenant" />
            </span>
            <p class="float-left mb-0">{{ tenant }}</p>
          </div>
          <div class="mr-4" v-if="store">
            <span class="float-left mr-2">
              <v-icon name="fa-store" scale="1.2" title="Tienda" />
            </span>
            <p class="float-left mb-0">{{ store }}</p>
          </div>
          <div class="position-relative">
            <div class="dropdown-toggle" id="dropdownOperations" data-toggle="dropdown"
              aria-haspopup="true">
              <span class="float-left mr-2">
                <v-icon name="fa-user" scale="1.2" />
              </span>
              <div class="header__link">
                <p class="float-left mb-0">
                  {{ username }}
                </p>
              </div>
            </div>
            <div class="dropdown-menu p-0 dropdown-menu-right" aria-labelledby="dropdownOperations">
              <span class="d-flex align-items-center">
                <a class="dropdown-item py-3 px-4" href="#" @click="changePassword();">
                  <v-icon name="io-lock-closed-outline" class="mr-2" scale="1.2" />
                  Cambiar contraseña
                </a>
              </span>
              <span class="d-flex align-items-center">
                <a class="dropdown-item py-3 px-4" href="#" @click="$logOut();">
                  <v-icon name="co-exit-to-app" class="mr-2" scale="1.2" />
                  Cerrar sesión
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Header',
  components: {
  },
  props: [
    'changeCollapse',
  ],
  data() {
    return {
      username: this.$cookies.get('username'),
      store: this.$cookies.get('store'),
      tenant: this.$cookies.get('tenant'),
      channel: this.$cookies.get('channel'),
      notifications: [],
    }
  },
  mounted() {
    if (!this.$store.state.roles.Backoffice_member_empresas) {
      axios.get(`/notifications-bo/search?pagination.pageSize=1&pagination.page=1`)
        .then((response) => {
          if(response.data && response.data.notificationsBo && response.data.notificationsBo.length > 0) {
            this.notifications = response.data.notificationsBo;
          }
        });
    }
  },
  methods: {
    changePassword() {
      this.$router.push({ name: 'change-password' })
    },
    notificationsUrl(notification){
      const url = notification.notificationName;
      const filterURL = encodeURIComponent(notification.notificationType);
      const query = { filterURL };
      const reload = (this.$route.name === url);
      this.$router.push({ name: url, query })
      .then(()=>{
        if(reload) {
          window.location.reload();
        }
      });
    },
    removeVuex(){
      this.$store.commit('RESET_STATE_CONTRACTS');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../../scss/variables.scss';

#menuIcon {
  color: rgb(40, 40, 40);
}

.dropdown-item {

  &:hover,
  &:focus {
    // background-color: transparent;
    color: $primary-text;
  }
}

.header {
  &__link {
    color: $primary-text;
    padding: 0;
    display: inline-block;
    cursor: pointer;

    &:hover {
      color: $primary;

      &::after {
        width: 80%;
      }
    }

    &::after {
      content: '';
      width: 0px;
      height: 1px;
      bottom: 0;
      display: block;
      background: $primary;
      transition: 300ms;
      position: absolute;
    }
  }
}

nav {
  height: 72px;
}
.numberNotification {
  position: absolute;
  top: -9px;
  right: 0px;
  color: white;
  border-radius: 100%;
  background-color: #cc0b7a;
  height: 17px;
  display: flex;
  font-size: smaller;
  justify-content: center;
  align-items: center;
  min-width: 17px;
  cursor: pointer;
  user-select: none;
}
</style>
